import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class StaffEndDayService extends DatabaseGwService {
  URL_PATH: string ="/staff-end-days";

  
}
